import React from 'react';
import { type UseFormReturn } from 'react-hook-form';

import { type IFieldReadinessSchema, readinessFieldDescriptions } from '../helper';
import { CardSection, SummaryHeader, SummarySection } from '../styled';

interface ISummaryProps {
	hookForm: UseFormReturn<IFieldReadinessSchema>;
}

const PrintReadinessInfo = ({ hookForm }: ISummaryProps) => {
	const values = hookForm.watch();
	const data = [
		{
			label: 'Volunteer Role',
			value: values.resultType ? 'Yes' : 'No',
		},
		{
			label: readinessFieldDescriptions.hasPartyAgentExperience.title,
			value: values.hasPartyAgentExperience ? 'Yes' : 'No',
		},
		{
			label: readinessFieldDescriptions.hasPowerBank.title,
			value: values.hasPowerBank ? 'Yes' : 'No',
		},
		{
			label: readinessFieldDescriptions.hasSmartPhoneWithInternet.title,
			value: values.hasSmartPhoneWithInternet ? 'Yes' : 'No',
		},
		{
			label: readinessFieldDescriptions.isAvailableAllDay.title,
			value: values.isAvailableAllDay ? 'Yes' : 'No',
		},
		{
			label: readinessFieldDescriptions.isNativeSpeaker.title,
			value: values.isNativeSpeaker ? 'Yes' : 'No',
		},
	];
	return (
		<div>
			<SummaryHeader>
				<p className='header'>Field Readiness</p>
			</SummaryHeader>
			<SummarySection>
				{data.map((dataItem) => (
					<CardSection key={dataItem.label}>
						<p className='label'>{dataItem.label}</p>
						<h5 className='value'>{dataItem.value}</h5>
					</CardSection>
				))}
			</SummarySection>
		</div>
	);
};

export default PrintReadinessInfo;
